import { createAction, createStandardAction } from 'typesafe-actions'
import { ComponentPayload } from './rio/clickstreamComponentViews'
import { UserClickPayload } from './rio/clickstreamInteractions'
import { SignupStartPayload } from './rio/clickstreamSignupStart'
import { SigninStartPayload } from './rio/clickstreamSignInStart'
import { ClickstreamNotificationPayload } from './rio/clickstreamNotifications'

export const INSTRUMENTATION_SYNTHETIC_LOCATION_CHANGE =
  'instrumentation/SYNTHETIC_LOCATION_CHANGE'
export const INSTRUMENTATION_RESET_SYNTHETIC_LOCATION_CHANGE =
  'instrumentation/RESET_SYNTHETIC_LOCATION_CHANGE'
export const INSTRUMENTATION_USER_CLICK_INTERACTION =
  'instrumentation/USER_CLICK_INTERACTION'
export const INSTRUMENTATION_INIT_RIO = 'instrumentation/INIT_RIO'
export const INSTRUMENTATION_SIGNUP_START = 'instrumentation/SIGNUP_START'
export const INSTRUMENTATION_SIGNIN_START = 'instrumentation/SIGNIN_START'
export const VIEW_AUTH_SIGN_IN_MODE = 'instrumentation/VIEW_AUTH_SIGN_IN_MODE'
export const VIEW_AUTH_SIGN_UP_MODE = 'instrumentation/VIEW_AUTH_SIGN_UP_MODE'
export const SIGN_IN_SUCCESS = 'instrumentation/SIGN_IN_SUCCESS'
export const CLICKSTREAM_NOTIFICATIONS = 'instrumentation/CLICKSTREAM_NOTIFICATIONS'
export const SIGN_UP_SUCCESS = 'instrumentation/SIGN_UP_SUCCESS'
export const SUCCESS = 'instrumentation/SUCCESS'
export const COMPONENT_VIEW = 'instrumentation/COMPONENT_VIEW'

export const toSearchResult = 'toSearchResult' as const
export const toAuthModal = 'toAuthModal' as const
export const toSubscriptionModal = 'toSubscriptionModal' as const
export const toCreateAccountExitPopup = 'toCreateAccountExitPopup' as const
export const toCheckPaperExitPopup = 'toCheckPaperExitPopup' as const
export const toModalCreateAccount = 'toModalCreateAccount' as const
export const toAccountStyleGateModal = 'toAccountStyleGateModal' as const
export const toAccountGateModal = 'toAccountGateModal' as const

export const VIDEO_DEMAND_SUCCESS = 'video demand success'
export const WORLDCAT_API_REQUEST = 'worldcat api request'
export const CLICKSTREAM_CREATE_CITATION = 'create citation'

export enum CLICKSTREAM_STATE {
  start = 'start',
  success = 'success',
  complete = 'complete',
  end = 'end',
  ready = 'ready',
  checkStart = 'checkStart',
  checkComplete = 'checkComplete',
  collapsed = 'collapsed',
  expanded = 'expanded',
}

export type AuthService = 'apple' | 'google' | 'chegg' | 'facebook' | 'internships'
export interface AuthSuccessPayload {
  authService: AuthService
}
export interface SuccessPayload {
  viewName: string
  value?: string
  state?: string
  style?: string
}

export type SyntheticRouteName =
  | typeof toSearchResult
  | typeof toAuthModal
  | typeof toSubscriptionModal
  | typeof toCreateAccountExitPopup
  | typeof toCheckPaperExitPopup
  | typeof toModalCreateAccount
  | typeof toAccountStyleGateModal
  | typeof toAccountGateModal

export type SyntheticLocationChangePayload = {
  routeName: SyntheticRouteName
  pageName?: string
}

export const syntheticLocationChange = createStandardAction(
  INSTRUMENTATION_SYNTHETIC_LOCATION_CHANGE
)<SyntheticLocationChangePayload>()

export const resetSyntheticLocationChange = createStandardAction(
  INSTRUMENTATION_RESET_SYNTHETIC_LOCATION_CHANGE
)()

export const userClick = createStandardAction(
  INSTRUMENTATION_USER_CLICK_INTERACTION
)<UserClickPayload>()

export const setInitRio = createStandardAction(INSTRUMENTATION_INIT_RIO)()

export const viewAuthSignInMode = () => createAction(VIEW_AUTH_SIGN_IN_MODE)()

export const viewAuthSignUpMode = () => createAction(VIEW_AUTH_SIGN_UP_MODE)()

export const emitSignInSuccessEvent = createStandardAction(
  SIGN_IN_SUCCESS
)<AuthSuccessPayload>()

export const emitNotificationEvent = createStandardAction(
  CLICKSTREAM_NOTIFICATIONS
)<ClickstreamNotificationPayload>()

export const emitSignUpSuccessEvent = createStandardAction(
  SIGN_UP_SUCCESS
)<AuthSuccessPayload>()

export const emitSuccessEvent = createStandardAction(SUCCESS)<SuccessPayload>()

export const emitComponentViewEvent = createStandardAction(
  COMPONENT_VIEW
)<ComponentPayload>()

export const signupStart = createStandardAction(
  INSTRUMENTATION_SIGNUP_START
)<SignupStartPayload>()
export const signinStart = createStandardAction(
  INSTRUMENTATION_SIGNIN_START
)<SigninStartPayload>()
